import { StandardUnit } from '../types/units';

/**
 * Maps extracted units from Gemini/TikTok to StandardUnit format
 * Gemini returns abbreviated units (g, ml, pcs, tbsp) but database expects full names
 */
export function mapToStandardUnit(extractedUnit: string): StandardUnit {
  const unitMap: Record<string, StandardUnit> = {
    // Weight
    'g': 'gram',
    'gram': 'gram',
    'grams': 'gram',
    'gramme': 'gram',
    'grammes': 'gram',
    'kg': 'kilogram',
    'kilo': 'kilogram',
    'kilogram': 'kilogram',
    'kilograms': 'kilogram',
    'kilogramme': 'kilogram',
    'kilogrammes': 'kilogram',
    
    // Volume
    'ml': 'milliliter',
    'milliliter': 'milliliter',
    'milliliters': 'milliliter',
    'millilitre': 'milliliter',
    'millilitres': 'milliliter',
    'cl': 'centiliter',
    'centiliter': 'centiliter',
    'centiliters': 'centiliter',
    'centilitre': 'centiliter',
    'centilitres': 'centiliter',
    'dl': 'deciliter',
    'deciliter': 'deciliter',
    'deciliters': 'deciliter',
    'décilitre': 'deciliter',
    'décilitres': 'deciliter',
    'l': 'liter',
    'liter': 'liter',
    'liters': 'liter',
    'litre': 'liter',
    'litres': 'liter',
    
    // Spoons
    'tsp': 'teaspoon',
    'teaspoon': 'teaspoon',
    'teaspoons': 'teaspoon',
    'cuillère à café': 'teaspoon',
    'cuillères à café': 'teaspoon',
    'c. à café': 'teaspoon',
    'cc': 'teaspoon',
    'tbsp': 'tablespoon',
    'tablespoon': 'tablespoon',
    'tablespoons': 'tablespoon',
    'cuillère à soupe': 'tablespoon',
    'cuillères à soupe': 'tablespoon',
    'c. à soupe': 'tablespoon',
    'cs': 'tablespoon',
    
    // Pieces
    'pcs': 'piece',
    'pc': 'piece',
    'piece': 'piece',
    'pieces': 'piece',
    'pièce': 'piece',
    'pièces': 'piece',
    'unit': 'piece',
    'units': 'piece',
    'unité': 'piece',
    'unités': 'piece',
    
    // Cup
    'cup': 'cup',
    'cups': 'cup',
    'tasse': 'cup',
    'tasses': 'cup'
  };

  const normalized = extractedUnit.toLowerCase().trim();
  return unitMap[normalized] || 'piece'; // Default to piece if unknown
}

